import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b681569"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
      /*#__PURE__*/_createElementVNode("h1", null, "Preferred locations")
    ])
  ])
], -1))
const _hoisted_2 = { class: "table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  width: "10%",
  class: "align-middle"
}, "Select", -1))
const _hoisted_4 = { class: "align-middle" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { Inspector, Location } from '@/models';
import LocationsPagination from "@/components/inspectors/LocationsPagination.vue";
import locations from '@/assets/json/locations.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'PreferredLocations',
  setup(__props) {

const store = useStore();

// Getters
const inspector = computed(() => store.getters['inspectors/current']);

// Actions
const addLocation = async (location: Location) => {
  await store.dispatch('inspectors/addLocation', location);
};

const removeLocation = async (location: Location) => {
  await store.dispatch('inspectors/removeLocation', location);
};

const setInspectorDeep = async (payload: { path: string; data: any }) => {
  await store.dispatch('inspectors/setInspectorDeep', payload);
};
// Reactive variables
const sortby = ref('code');
const ascdesc = ref('asc');


// State
const _locationindex = ref<number>(-1);
const ratingOptions = ["1", "2", "3"];
const filteredlocations = ref<any[]>([]);

// Methods
const addNewLocation = () => {
  const newlocation = new Location();
  addLocation(newlocation);
};
const _delete = (l: Location) => {
  const confirm = window.confirm("Are you sure you want to delete this location?");
  if (confirm) {
    removeLocation(l)
      .then(() => console.log('Deleted')) // Replace with your desired action
      .catch((err: any) => console.error(err)); // Replace with your desired error handling
  }
};

const selected = (l: any): Location | undefined => {
  const index = inspector.value.locations.findIndex(
    (location) => location.code === l.code
  );
  return index >= 0 ? inspector.value.locations[index] : undefined;
};

const selectedindex = (l: any): number => {
  const index = inspector.value.locations.findIndex(
    (location) => location.code === l.code
  );
  return index;
};
const select = (l: any): Promise<any> => {
  const newlocation = new Location();
  newlocation.rating = 1;
  newlocation.code = l.code;
  newlocation.name = l.name;
  return addLocation(newlocation);
};

const unselect = (l: any) => {
  const location = selected(l);
  if (location) removeLocation(location);
};

const rating = (l: any, r: number) => {
  select(l).then(() => {
    const index = selectedindex(l);
    if (index >= 0) {
      if(inspector.value.locations[index].rating === 1) r = 0;
      setInspectorDeep({ path: `locations[${index}].rating`, data: r });
    }
  });
};

const isRating = (l: any, r: number): boolean => {
  const location = selected(l);
  return location && location.rating >= r;
};

// Methods
const togglesort = (by: string) => {
  if (sortby.value === by) {
    ascdesc.value = ascdesc.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortby.value = by;
    ascdesc.value = 'asc';
  }
};

// Methods
const filterLocations = (starts_with: string) => {
  filteredlocations.value = locations
    .filter((l: any) => {
      return String(l.code).toLowerCase().startsWith(starts_with);
    })
    .sort((l1: any, l2: any) => l1.code.localeCompare(l2.code));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(LocationsPagination, { onFilter: filterLocations }),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_3,
          _createElementVNode("th", {
            class: "align-middle",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (togglesort('name')))
          }, [
            _createTextVNode(" Name "),
            _createElementVNode("i", {
              class: _normalizeClass(["fas", {
              'fa-angle-up': sortby.value === 'name' && ascdesc.value === 'asc',
              'fa-angle-down': sortby.value === 'name' && ascdesc.value === 'desc',
            }])
            }, null, 2)
          ]),
          _createElementVNode("th", {
            class: "align-middle",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (togglesort('code')))
          }, [
            _createTextVNode(" Code "),
            _createElementVNode("i", {
              class: _normalizeClass(["fas", {
              'fa-angle-up': sortby.value === 'code' && ascdesc.value === 'asc',
              'fa-angle-down': sortby.value === 'code' && ascdesc.value === 'desc',
            }])
            }, null, 2)
          ]),
          _createElementVNode("th", {
            class: "align-middle",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (togglesort('rating')))
          }, [
            _createTextVNode(" Rating "),
            _createElementVNode("i", {
              class: _normalizeClass(["fas", {
              'fa-angle-up': sortby.value === 'rating' && ascdesc.value === 'asc',
              'fa-angle-down': sortby.value === 'rating' && ascdesc.value === 'desc',
            }])
            }, null, 2)
          ])
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredlocations.value, (location, $locationindex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: $locationindex,
            class: _normalizeClass({ 'selected-location': selected(location) })
          }, [
            _createElementVNode("td", _hoisted_4, [
              (selected(location))
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-check text-success fa-2x",
                    onClick: ($event: any) => (unselect(location))
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: "fas fa-check fa-2x",
                    onClick: ($event: any) => (select(location))
                  }, null, 8, _hoisted_6))
            ]),
            _createElementVNode("td", null, _toDisplayString(location.name), 1),
            _createElementVNode("td", null, _toDisplayString(location.code), 1),
            (selected(location))
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fas fa-star fa-2x", {
              'selected-star': isRating(location, 1),
              'unselected-star': !isRating(location, 1),
            }]),
                    onClick: ($event: any) => (rating(location, 1))
                  }, null, 10, _hoisted_8),
                  _createElementVNode("i", {
                    class: _normalizeClass(["fas fa-star fa-2x", {
              'selected-star': isRating(location, 2),
              'unselected-star': !isRating(location, 2),
            }]),
                    onClick: ($event: any) => (rating(location, 2))
                  }, null, 10, _hoisted_9),
                  _createElementVNode("i", {
                    class: _normalizeClass(["fas fa-star fa-2x", {
              'selected-star': isRating(location, 3),
              'unselected-star': !isRating(location, 3),
            }]),
                    onClick: ($event: any) => (rating(location, 3))
                  }, null, 10, _hoisted_10)
                ]))
              : (_openBlock(), _createElementBlock("td", _hoisted_11, [
                  _createElementVNode("i", {
                    class: "fas fa-star fa-2x disabled-start",
                    onClick: ($event: any) => (rating(location, 1))
                  }, null, 8, _hoisted_12),
                  _createElementVNode("i", {
                    class: "fas fa-star fa-2x disabled-start",
                    onClick: ($event: any) => (rating(location, 2))
                  }, null, 8, _hoisted_13),
                  _createElementVNode("i", {
                    class: "fas fa-star fa-2x disabled-start",
                    onClick: ($event: any) => (rating(location, 3))
                  }, null, 8, _hoisted_14)
                ]))
          ], 2))
        }), 128))
      ])
    ])
  ]))
}
}

})